import { Card, Grid } from '@mui/material';
import React from 'react';
import { useState } from 'react';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import Gene20Button from '../../../Components/Gene20Button';
import Gene20Typography from '../../../Components/Gene20Typography';
import shopsData from '../data/shopsData';

const ProductDetails = () => {
  const [show, setShow] = useState(false);
  const toggleModal = () => setShow(!show);
  return (
    <Grid container>
      {shopsData.map((product, index) => (
        <Grid item xs={6} sm={4} key={index}>
          <Gene20Box>
            <Card
              component="img"
              sx={{ overflow: 'hidden', width: 200, mb: '1rem', height: 200 }}
              src={product.image}
            />
          </Gene20Box>
          <Gene20Box>
            <Gene20Typography variant="body1">
              <strong>product</strong>:{product.name}
            </Gene20Typography>
            <Gene20Typography variant="body1">
              <strong>price</strong> :{product.price}
            </Gene20Typography>
            <Gene20Typography variant="body1">
              <strong>shop</strong> :{product.shopName}
            </Gene20Typography>
          </Gene20Box>
          <Gene20Box>
            <Gene20Button
              variant="contained"
              onClick={toggleModal}
              sx={{ width: 200, mb: '1rem' }}
              color="secondary"
            >
              order
            </Gene20Button>
            <Gene20Button variant="contained" color="primary" sx={{ width: 200 }}>
              visit shop
            </Gene20Button>
          </Gene20Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductDetails;
